export const LOCAL_BGM_DEEP_URBAN = require("./deep_urban.mp3");
